var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Fragment',_vm._l((_vm.videoLinks),function(linkData){return _c('VideoEventsCard',{key:linkData.id,staticClass:"span-6",attrs:{"data":linkData,"is-loading-links":_vm.isLoadingLinks}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }